import { render } from "./Releases.vue?vue&type=template&id=630f788f&scoped=true"
import script from "./Releases.vue?vue&type=script&lang=js"
export * from "./Releases.vue?vue&type=script&lang=js"

import "./Releases.vue?vue&type=style&index=0&id=630f788f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rights.tokyo/rights.tokyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630f788f"]])

export default __exports__